<template>
  <div
    @mouseenter="addScrollTrack()"
    @mouseleave="removeScrollTrack()"
    class="absolute bottom-0 z-10 flex flex-col gap-1 justify-center items-center w-full opacity-75">
    <div class="flex gap-1 p-1 h-8 w-1/3 bg-white rounded-md">
      <button
        @click="toChangeSpeed()"
        type="button"
        class="flex justify-center items-center px-2 w-6 h-6 bg-white-500 shadow-md rounded-md">
        <span class="text-xs text-slate-500">{{ history.speed }}x</span>
      </button>
      <input
        :max="history.lastIndex"
        :value="history.index"
        class="flex-1"
        type="range"
        min="1"
        disabled />
      <button
        v-if="history.index != 0"
        @click="toStopTrack()"
        type="button"
        class="flex justify-center items-center px-2 w-6 h-6 bg-red-500 shadow-md rounded-md">
        <i class="material-icons text-sm text-white">stop_circle</i>
      </button>
      <button
        @click="toToggleTrack()"
        type="button"
        class="flex justify-center px-2 items-center w-6 h-6 bg-green-500 shadow-md rounded-md">
        <i class="material-icons text-sm text-white">{{ history.mode === 'play' ? 'pause_circle_outline' : 'play_circle_outline' }}</i>
      </button>
    </div>
    <div class="w-1/3 bg-gray-500 rounded-tl-lg rounded-tr-lg">
      <div class="flex flex-col align-center justify-center px-3 py-3 mb-3 bg-gray-300 rounded-md">
        <p class="text-xs font-bold text-slate-500 text-center">{{ kapal.nama_kapal }}</p>
        <p class="text-xs text-slate-500 text-center">{{ kapal.transmitter }}</p>
      </div>
      <div class="flex flex-col items-center justify-center mb-3">
        <div class="flex flex-row px-3 gap-3 items-center justify-center">
          <div class="flex items-center">
            <i class="material-icons text-sm text-white mr-1">event</i>
            <span class="text-xs text-gray-300">{{ utcFormatTimes(history.indexed.PING_TIME) }}</span>
          </div>
        </div>
        <div class="flex flex-row px-3 gap-1 items-center justify-center">
          <i class="material-icons text-sm text-white">location_on</i>
          <span class="text-xs text-gray-300">{{ latString(history.indexed.LATITUDE) }}</span>
          <span class="text-xs text-gray-300">{{ lonString(history.indexed.LONGITUDE) }}</span>
        </div>
        <div class="flex flex-row px-3 gap-1 items-center justify-center">
          <i class="material-icons text-sm text-white">location_on</i>
          <span class="text-xs text-gray-300">{{ history.indexed.LATITUDE }}, {{ history.indexed.LONGITUDE }}</span>
        </div>
        <div class="flex flex-row px-3 gap-1 items-center justify-center">
          <div class="flex items-center">
            <i class="material-icons text-sm text-white mr-1">speed</i>
            <span class="text-xs text-gray-300">{{ history.indexed.SPEED / 10 }} knot</span>
          </div>
          <div class="flex items-center">
            <i class="material-icons text-sm text-white mr-1">explore</i>
            <p class="flex flex-col">
              <span class="text-xs text-gray-300">{{ history.indexed.HEADING }}°</span>
            </p>
          </div>
        </div>
      </div>
      <div class="flex flex-row">
        <button
          @click="toFirstTrack()"
          :disabled="history.index < 1"
          class="flex flex-grow items-center justify-center h-12 bg-gray-400 border border-gray-300"
          type="button">
          <i class="material-icons text-white">first_page</i>
        </button>
        <button
          @click="toPreviousTrack()"
          :disabled="history.index < 1"
          class="flex flex-grow items-center justify-center h-12 bg-gray-400 border border-gray-300"
          type="button">
          <i class="material-icons text-white">arrow_back_ios</i>
        </button>
        <span class="flex p-3 items-center justify-center text-xs text-white h-12 bg-gray-400">{{ history.index + 1 }} / {{ history.lastIndex + 1 }}</span>
        <button
          @click="toNextTrack()"
          :disabled="history.index >= history.lastIndex"
          class="flex flex-grow items-center justify-center h-12 bg-gray-400 border border-gray-300"
          type="button">
          <i class="material-icons text-white">arrow_forward_ios</i>
        </button>
        <button
          @click="toLastTrack()"
          :disabled="history.index >= history.lastIndex"
          class="flex flex-grow items-center justify-center h-12 bg-gray-400 border border-gray-300"
          type="button">
          <i class="material-icons text-white">last_page</i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import libs from '../libs'

export default {
  name: 'InfoHistoryKapal',
  data: () => ({
    scrollTrack: null
  }),
  computed: {
    ...mapGetters([
      'kapal',
      'history'
    ])
  },
  methods: {
    ...mapActions([
      'toStopTrack',
      'toToggleTrack',
      'toFirstTrack',
      'toPreviousTrack',
      'toNextTrack',
      'toLastTrack',
      'toChangeSpeed'
    ]),
    utcFormatTimes: (d) => libs.localTime(d, 'full', false, false, false),
    latString: (lat) => libs.dmsToString(libs.decToDMS(lat), 'LU', 'LS'),
    lonString: (lon) => libs.dmsToString(libs.decToDMS(lon), 'BT', 'BB'),
    addScrollTrack: function () {
      if (this.scrollTrack === null) {
        this.scrollTrack = window.addEventListener('wheel', this.handleScrollTrack)
      }
    },
    removeScrollTrack: function () {
      if (this.scrollTrack) {
        window.removeEventListener('wheel', this.scrollTrack)
      }
    },
    handleScrollTrack: function (e) {
      if (e.deltaY < 0) {
        this.toNextTrack()
      } else if (e.deltaY > 0) {
        this.toPreviousTrack()
      }
    }
  }
}
</script>
